(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["author_page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    var el = document.querySelector('[data-author-back]');
    if (!el) return;
    var ref = document.referrer;
    if (!ref) return;
    try {
      var u = new URL(ref);
      if (u.origin === window.location.origin && u.href !== window.location.href) {
        el.setAttribute('href', u.href);
        var parts = u.pathname.split('/').filter(Boolean);
        if (parts[0] === 'blogs' && parts.length >= 3) {
          el.textContent = '← Zurück zum Beitrag';
        }
      }
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal_list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var pill = e.target.closest('.journal-pill');
  if (!pill) return;
  var root = pill.closest('[data-journal-list]');
  if (!root) return;
  var filter = pill.getAttribute('data-filter');
  root.querySelectorAll('.journal-pill').forEach(function (p) { p.classList.toggle('is-active', p === pill); });
  root.querySelectorAll('.journal-card').forEach(function (card) {
    var cats = (card.getAttribute('data-cats') || '').split(' ');
    var show = filter === 'all' || cats.indexOf(filter) !== -1;
    card.classList.toggle('is-hidden', !show);
  });
});

  } catch(e) { console.error(e); }
})();
})();
